'use strict';

// jstimezonedetect 1.0.5 does not export default but never versions do. In future version we can just publish jstz.js as index.js
module.exports = require('./jstz').jstz;